import styles from './NoTaskList.module.css'

export interface NoTaskListProps {
  testId?: string
}

export function NoTaskList({ testId }: NoTaskListProps) {
  return (
    <div className={styles.root} data-test={testId}>
      <p className={styles.description}>You have no outstanding tasks.</p>
    </div>
  )
}
